import { render, staticRenderFns } from "./FixedCart.vue?vue&type=template&id=ed444664&scoped=true&v-if=getGameConsole%20%3D%3D%3D%20'default'"
import script from "./FixedCart.vue?vue&type=script&lang=js"
export * from "./FixedCart.vue?vue&type=script&lang=js"
import style0 from "./FixedCart.vue?vue&type=style&index=0&id=ed444664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed444664",
  null
  
)

export default component.exports